import { useCallback, useEffect, useMemo, useState } from 'react'
import IssuesByStatusService from '../../../services/api/IssuesByStatusService'
import { CATEGORIES, categoryLabel } from '../IssueStatuses/constants'

const noop = () => null

export const toStatus = row => ({
  id: row.id,
  name: row.name,
  color: row.color,
  category: row.category,
  count: row.count ?? 0
})

export const groupByCategory = statuses => CATEGORIES.map(({ value }) => {
  const rows = statuses.filter(status => status.category === value)
  return {
    category: value,
    label: categoryLabel(value),
    statuses: rows,
    total: rows.reduce((sum, status) => sum + status.count, 0)
  }
})

const useIssuesByStatus = (
  collectId, { search, issueStatus, draftId, startDate, endDate, enabled = true }
) => {
  const [statuses, setStatuses] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refetchToken, setRefetchToken] = useState(0)

  const refetch = useCallback(() => setRefetchToken(token => token + 1), [])

  useEffect(() => {
    if (!enabled)
      return noop
    let cancelled = false
    setLoading(true)
    setError(null)

    const fetchOptions = { search, issueStatus, draftId, startDate, endDate }
    IssuesByStatusService.getIssuesByStatus(collectId, fetchOptions)
      .then(response => {
        if (cancelled)
          return
        const rows = Array.isArray(response) ? response : []
        setStatuses(rows.map(toStatus))
      })
      .catch(err => {
        if (cancelled)
          return
        setError(err)
        setStatuses([])
      })
      .finally(() => {
        if (!cancelled)
          setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [collectId, search, issueStatus, draftId, startDate, endDate, enabled, refetchToken])

  const groups = useMemo(() => groupByCategory(statuses), [statuses])

  return { groups, loading, error, refetch }
}

export default useIssuesByStatus
